
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _4045VkHVFklaIMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/404.vue?macro=true";
import { default as about_45usNni2RmGPfjMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/about-us.vue?macro=true";
import { default as activity_45logsx5IoFOpJEMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/activity-log.vue?macro=true";
import { default as AddressCardxwXcpOV8fCMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/components/AddressCard.vue?macro=true";
import { default as AddressModalgUX6QzqQ6WMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/components/AddressModal.vue?macro=true";
import { default as indexFWVvKGoFrDMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/index.vue?macro=true";
import { default as _91id_93gDkZvVsgn7Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/attributes/[id].vue?macro=true";
import { default as indexnkVj4BqPd2Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/attributes/index.vue?macro=true";
import { default as _91id_93Radzemh9dQMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/categories/[id].vue?macro=true";
import { default as indexRZPefYTkvQMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/categories/index.vue?macro=true";
import { default as couponsUWcqvU2apLMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/coupons.vue?macro=true";
import { default as dashboardqZdAZxTuWMMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/dashboard.vue?macro=true";
import { default as exclusive_offersNOnw3c52S2Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/exclusive_offers.vue?macro=true";
import { default as _91id_93QOkb5GWRb6Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/governorates/[id].vue?macro=true";
import { default as indexXNyhrYp3huMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/governorates/index.vue?macro=true";
import { default as _91id_93ZZlriNNa6FMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/homepage_offers/[id].vue?macro=true";
import { default as indexq1Ll4E41eqMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/homepage_offers/index.vue?macro=true";
import { default as indexMVnB3k8vYaMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/index.vue?macro=true";
import { default as logsifqDdZ5ZWGMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/logs.vue?macro=true";
import { default as manage_ads2llJo8C5JzMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_ads.vue?macro=true";
import { default as manage_complaintsTr7VteYXcHMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_complaints.vue?macro=true";
import { default as manage_newsNanDJWiNyXMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_news.vue?macro=true";
import { default as manage_seozywEaNSpmWMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_seo.vue?macro=true";
import { default as manage_unarchived_requests0zqmbarZR2Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_unarchived_requests.vue?macro=true";
import { default as my_profile_settingsedUiOw0CgyMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/my_profile_settings.vue?macro=true";
import { default as _91id_93rrnl1qeXeiMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/nested_main_attributes/[id].vue?macro=true";
import { default as _91id_93qqGDSAlPIJMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/nested_sub_attributes/[id].vue?macro=true";
import { default as notification_45logsCeJsY4U1o8Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/notification-logs.vue?macro=true";
import { default as offers4BIyPocTD6Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/offers.vue?macro=true";
import { default as ordersePKY97WdhLMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/orders.vue?macro=true";
import { default as package_invoices7cGT4UZLyHMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/package_invoices.vue?macro=true";
import { default as _91id_93nGJ2WrhK6JMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/packages/[id].vue?macro=true";
import { default as indexVMHGkk79pWMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/packages/index.vue?macro=true";
import { default as productspFRRubAQufMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/products.vue?macro=true";
import { default as orderscZRZFshoJyMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/orders.vue?macro=true";
import { default as productsQEYQ5VX3QxMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/products.vue?macro=true";
import { default as storesjPKidnFDvUMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/stores.vue?macro=true";
import { default as adminseI7xzUYlR6Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/admins.vue?macro=true";
import { default as moderatorsfRefMceb2UMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/moderators.vue?macro=true";
import { default as resellers8c9LZfM5tuMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/resellers.vue?macro=true";
import { default as sub_resellersz1bAfdNTTsMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/sub_resellers.vue?macro=true";
import { default as usersvrGtarOiY8Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/users.vue?macro=true";
import { default as search_keywordsKRGaHpDi9IMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/search_keywords.vue?macro=true";
import { default as manage_adsNiekPp5EKjMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_ads.vue?macro=true";
import { default as manage_notificationsKx6EeEx7oBMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_notifications.vue?macro=true";
import { default as manage_policies_verificationAyHYn6Sw3SMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_policies_verification.vue?macro=true";
import { default as manage_seozGx2sMIdexMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_seo.vue?macro=true";
import { default as manage_websiteA7r7KUgE7CMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_website.vue?macro=true";
import { default as manage_45pointsNf3HFtP56WMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage-points.vue?macro=true";
import { default as wizardiNvS7nceKpMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/wizard.vue?macro=true";
import { default as stores_verification_requestsFA1IkmzbaaMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/stores_verification_requests.vue?macro=true";
import { default as stores0n5umrJok2Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/stores.vue?macro=true";
import { default as indexLr7LuHvrQZMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/warnings/index.vue?macro=true";
import { default as withdrawal_45requests2juZmpOOpnMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/withdrawal-requests.vue?macro=true";
import { default as Cart_2L1AmgAmuvtMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/Cart_2.vue?macro=true";
import { default as cartx2EwTwKZrjMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/cart.vue?macro=true";
import { default as categoriesAgMO936xHtMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/categories.vue?macro=true";
import { default as _91id_93SmB7wEqu0QMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/category-content/[id].vue?macro=true";
import { default as _91_91chatId_93_93RV6DCpSasvMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/chats/[[chatId]].vue?macro=true";
import { default as contact_45usgZoQcegC7gMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/contact-us.vue?macro=true";
import { default as delivery_45locationsMJFwdCUVnNMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/delivery-locations.vue?macro=true";
import { default as _91_91id_93_938SwOTirQDNMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/exclusive_offers/[[id]].vue?macro=true";
import { default as _91_91type_93_93ewpQor97dJMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/favourite/[[type]].vue?macro=true";
import { default as follow_upH5gcPLiH41Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/follow_up.vue?macro=true";
import { default as followersjsfmlLH5GoMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/followers.vue?macro=true";
import { default as indexvse7dtAc8nMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/index.vue?macro=true";
import { default as _91_91type_93_935AdsvdmjEJMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/login/[[type]].vue?macro=true";
import { default as dashboardtn6KIEnVD3Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/dashboard.vue?macro=true";
import { default as index3bSNRcvtjaMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/index.vue?macro=true";
import { default as logsGpcjwjM0gPMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/logs.vue?macro=true";
import { default as my_profile_settingsAisWiI7QArMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/my_profile_settings.vue?macro=true";
import { default as notification_45logsn3nINxc6Q8Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/notification-logs.vue?macro=true";
import { default as offersyU90D4QLLrMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/offers.vue?macro=true";
import { default as ordersox3BLbip7cMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/orders.vue?macro=true";
import { default as productsMedL82FC5eMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/products.vue?macro=true";
import { default as ordersKzTHuCbyuvMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/orders.vue?macro=true";
import { default as productsESbHARm3SHMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/products.vue?macro=true";
import { default as storeseYgPZnkRObMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/stores.vue?macro=true";
import { default as resellersAHPiqn1mbfMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/resellers.vue?macro=true";
import { default as sub_resellersG8a5f7zpOhMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/sub_resellers.vue?macro=true";
import { default as usersMNNQ6rEA6eMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/users.vue?macro=true";
import { default as search_keywordsB7GfDpG54WMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/search_keywords.vue?macro=true";
import { default as storesgfxK6tNA33Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/stores.vue?macro=true";
import { default as indexRlysUhJ1WYMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/warnings/index.vue?macro=true";
import { default as MyStoreCardIqnup8JWDrMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/MyStoreCard.vue?macro=true";
import { default as PaymentComponentdbLxZuXkIVMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/PaymentComponent.vue?macro=true";
import { default as RenewOptionsButtonGM6NVAfIGaMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/RenewOptionsButton.vue?macro=true";
import { default as ShareButtonzJo5u73LDkMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/ShareButton.vue?macro=true";
import { default as indexGdSaHbOKd9Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/index.vue?macro=true";
import { default as _91id_93knlBwq2WBlMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/news/[id].vue?macro=true";
import { default as notificationsGX5yoZpYmMMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/notifications.vue?macro=true";
import { default as ordersLAYQ1m1x6pMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/orders.vue?macro=true";
import { default as otpJruII9aRhQMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/otp.vue?macro=true";
import { default as LogincgDROMYYXLMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/panel/Login.vue?macro=true";
import { default as _91_91from_93_93Lt8cwC8T5WMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/payment-state/[[from]].vue?macro=true";
import { default as privacy_45policyBAiw2wVJCOMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/privacy-policy.vue?macro=true";
import { default as indexnfEdQF7RbQMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/[[productname]]/index.vue?macro=true";
import { default as order_45detailsq7WU3Kr0DsMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/[[productname]]/order-details.vue?macro=true";
import { default as MakingReportModalJ5p82DW25kMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/MakingReportModal.vue?macro=true";
import { default as index9eoyMyqA4fMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/products/index.vue?macro=true";
import { default as index3XuM6hdVbtMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/products/store-password/index.vue?macro=true";
import { default as _91_91type_93_93AIvAiHiCjIMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/profile/[[type]].vue?macro=true";
import { default as promotion4MgFaEaQ72Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/promotion.vue?macro=true";
import { default as rating_45managementjk66strsZHMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/rating-management.vue?macro=true";
import { default as _91id_93JAWW9R8czXMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/rating/[type]/[id].vue?macro=true";
import { default as brancheseF0SrziZGXMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/branches.vue?macro=true";
import { default as dashboardKcpr5b3LfXMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/dashboard.vue?macro=true";
import { default as _91_91store_93_93EHrMvCR0NGMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/delivery_governorates/[[store_id]]/[[store]].vue?macro=true";
import { default as exclusive_offersezkq1namFYMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/exclusive_offers.vue?macro=true";
import { default as index2WMsLk3SWnMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/index.vue?macro=true";
import { default as addcL38UnihG1Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ads/add.vue?macro=true";
import { default as indexDGb4rP13nDMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ads/index.vue?macro=true";
import { default as manage_newsIwkSPD763JMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_news.vue?macro=true";
import { default as manage_ratings7K9Uq32sATMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ratings.vue?macro=true";
import { default as my_profile_settingsShwuhgpNtiMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/my_profile_settings.vue?macro=true";
import { default as ordersrMqKslKONtMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/orders.vue?macro=true";
import { default as package_invoices03nKj0g83CMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/package_invoices.vue?macro=true";
import { default as product_couponsiKAKfO2FtPMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/product_coupons.vue?macro=true";
import { default as products49pvZYLMEmMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/products.vue?macro=true";
import { default as ordersBckE5sOYarMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/orders.vue?macro=true";
import { default as productsJlgAuXcaWUMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/products.vue?macro=true";
import { default as storesqtVuASJQqSMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/stores.vue?macro=true";
import { default as stores_verificationu08A3OvIzDMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/stores_verification.vue?macro=true";
import { default as storesh8hiR6VBU3Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/stores.vue?macro=true";
import { default as sub_resellersceOAhh7shBMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/sub_resellers.vue?macro=true";
import { default as indexd43HI24VKXMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/search/index.vue?macro=true";
import { default as with_45filter7wYKfmpjkFMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/search/with-filter.vue?macro=true";
import { default as security_settings53Za9zhRsPMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/security_settings.vue?macro=true";
import { default as _91id_93wmRi2bwpvxMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/store-settings/[id].vue?macro=true";
import { default as LocationsZI6izcUdavMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/store-settings/components/Locations.vue?macro=true";
import { default as _91_91username_93_9360gscCyJ9fMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/store/[[username]].vue?macro=true";
import { default as _91_91username_93_93HjiULD3sTFMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/store/store-password/[[username]].vue?macro=true";
import { default as indexAAZCuZgdMEMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/stores/index.vue?macro=true";
import { default as branchestKSRexgPs9Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/branches.vue?macro=true";
import { default as dashboardqURm6SeDdvMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/dashboard.vue?macro=true";
import { default as exclusive_offersAwFjEiogiuMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/exclusive_offers.vue?macro=true";
import { default as indexueKd7uNfzZMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/index.vue?macro=true";
import { default as add4O2c0mjbWkMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ads/add.vue?macro=true";
import { default as indexUdnTElbgisMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ads/index.vue?macro=true";
import { default as manage_newszrLwJ28ne9Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_news.vue?macro=true";
import { default as manage_ratingssbufdVdbteMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ratings.vue?macro=true";
import { default as my_profile_settings500AEZghvAMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/my_profile_settings.vue?macro=true";
import { default as ordersX6050F7EmYMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/orders.vue?macro=true";
import { default as package_invoicesHHiFHwYvK9Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/package_invoices.vue?macro=true";
import { default as product_couponsZdPSfWaF2tMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/product_coupons.vue?macro=true";
import { default as productsOiBhLbmuQGMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/products.vue?macro=true";
import { default as stores_verificationY6xx9oCeYoMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/stores_verification.vue?macro=true";
import { default as storeseBGzHcvdssMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/stores.vue?macro=true";
import { default as terms_45condition0YRfYB7cEaMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/terms-condition.vue?macro=true";
import { default as test_45seoJgxIvRcSHZMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/test-seo.vue?macro=true";
import { default as test_45social_45previewxbv3iawg9cMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/test-social-preview.vue?macro=true";
import { default as _91_91type_93_93BusXyGV5sYMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/upgrade/[[type]].vue?macro=true";
import { default as indexaldRPcjRLMMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/verify_my_store/index.vue?macro=true";
import { default as verification_processXsnUbOAsDUMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/verify_my_store/verification_process.vue?macro=true";
import { default as walletzkKMaE1OKOMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/wallet.vue?macro=true";
import { default as win_45with_45cezmaWU7eysFcR1Meta } from "/home/nuxt-front-end-V2/nuxt-front-end/pages/win-with-cezma.vue?macro=true";
import { default as component_45stubpEHXXpoq5iMeta } from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubpEHXXpoq5i } from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404",
    path: "/404",
    meta: _4045VkHVFklaIMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/404.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usNni2RmGPfjMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/about-us.vue")
  },
  {
    name: "activity-log",
    path: "/activity-log",
    meta: activity_45logsx5IoFOpJEMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/activity-log.vue")
  },
  {
    name: "addresses-components-AddressCard",
    path: "/addresses/components/AddressCard",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/components/AddressCard.vue")
  },
  {
    name: "addresses-components-AddressModal",
    path: "/addresses/components/AddressModal",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/components/AddressModal.vue")
  },
  {
    name: "addresses",
    path: "/addresses",
    meta: indexFWVvKGoFrDMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/addresses/index.vue")
  },
  {
    name: "admin-attributes-id",
    path: "/admin/attributes/:id()",
    meta: _91id_93gDkZvVsgn7Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/attributes/[id].vue")
  },
  {
    name: "admin-attributes",
    path: "/admin/attributes",
    meta: indexnkVj4BqPd2Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/attributes/index.vue")
  },
  {
    name: "admin-categories-id",
    path: "/admin/categories/:id()",
    meta: _91id_93Radzemh9dQMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/categories/[id].vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: indexRZPefYTkvQMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/categories/index.vue")
  },
  {
    name: "admin-coupons",
    path: "/admin/coupons",
    meta: couponsUWcqvU2apLMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/coupons.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: dashboardqZdAZxTuWMMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/dashboard.vue")
  },
  {
    name: "admin-exclusive_offers",
    path: "/admin/exclusive_offers",
    meta: exclusive_offersNOnw3c52S2Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/exclusive_offers.vue")
  },
  {
    name: "admin-governorates-id",
    path: "/admin/governorates/:id()",
    meta: _91id_93QOkb5GWRb6Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/governorates/[id].vue")
  },
  {
    name: "admin-governorates",
    path: "/admin/governorates",
    meta: indexXNyhrYp3huMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/governorates/index.vue")
  },
  {
    name: "admin-homepage_offers-id",
    path: "/admin/homepage_offers/:id()",
    meta: _91id_93ZZlriNNa6FMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/homepage_offers/[id].vue")
  },
  {
    name: "admin-homepage_offers",
    path: "/admin/homepage_offers",
    meta: indexq1Ll4E41eqMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/homepage_offers/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexMVnB3k8vYaMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/index.vue")
  },
  {
    name: "admin-logs",
    path: "/admin/logs",
    meta: logsifqDdZ5ZWGMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/logs.vue")
  },
  {
    name: "admin-manage_ads",
    path: "/admin/manage_ads",
    meta: manage_ads2llJo8C5JzMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_ads.vue")
  },
  {
    name: "admin-manage_complaints",
    path: "/admin/manage_complaints",
    meta: manage_complaintsTr7VteYXcHMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_complaints.vue")
  },
  {
    name: "admin-manage_news",
    path: "/admin/manage_news",
    meta: manage_newsNanDJWiNyXMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_news.vue")
  },
  {
    name: "admin-manage_seo",
    path: "/admin/manage_seo",
    meta: manage_seozywEaNSpmWMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_seo.vue")
  },
  {
    name: "admin-manage_unarchived_requests",
    path: "/admin/manage_unarchived_requests",
    meta: manage_unarchived_requests0zqmbarZR2Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/manage_unarchived_requests.vue")
  },
  {
    name: "admin-my_profile_settings",
    path: "/admin/my_profile_settings",
    meta: my_profile_settingsedUiOw0CgyMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/my_profile_settings.vue")
  },
  {
    name: "admin-nested_main_attributes-id",
    path: "/admin/nested_main_attributes/:id()",
    meta: _91id_93rrnl1qeXeiMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/nested_main_attributes/[id].vue")
  },
  {
    name: "admin-nested_sub_attributes-id",
    path: "/admin/nested_sub_attributes/:id()",
    meta: _91id_93qqGDSAlPIJMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/nested_sub_attributes/[id].vue")
  },
  {
    name: "admin-notification-logs",
    path: "/admin/notification-logs",
    meta: notification_45logsCeJsY4U1o8Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/notification-logs.vue")
  },
  {
    name: "admin-offers",
    path: "/admin/offers",
    meta: offers4BIyPocTD6Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/offers.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: ordersePKY97WdhLMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/orders.vue")
  },
  {
    name: "admin-package_invoices",
    path: "/admin/package_invoices",
    meta: package_invoices7cGT4UZLyHMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/package_invoices.vue")
  },
  {
    name: "admin-packages-id",
    path: "/admin/packages/:id()",
    meta: _91id_93nGJ2WrhK6JMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/packages/[id].vue")
  },
  {
    name: "admin-packages",
    path: "/admin/packages",
    meta: indexVMHGkk79pWMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/packages/index.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: productspFRRubAQufMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/products.vue")
  },
  {
    name: "admin-reports-orders",
    path: "/admin/reports/orders",
    meta: orderscZRZFshoJyMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/orders.vue")
  },
  {
    name: "admin-reports-products",
    path: "/admin/reports/products",
    meta: productsQEYQ5VX3QxMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/products.vue")
  },
  {
    name: "admin-reports-stores",
    path: "/admin/reports/stores",
    meta: storesjPKidnFDvUMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/reports/stores.vue")
  },
  {
    name: "admin-roles-admins",
    path: "/admin/roles/admins",
    meta: adminseI7xzUYlR6Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/admins.vue")
  },
  {
    name: "admin-roles-moderators",
    path: "/admin/roles/moderators",
    meta: moderatorsfRefMceb2UMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/moderators.vue")
  },
  {
    name: "admin-roles-resellers",
    path: "/admin/roles/resellers",
    meta: resellers8c9LZfM5tuMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/resellers.vue")
  },
  {
    name: "admin-roles-sub_resellers",
    path: "/admin/roles/sub_resellers",
    meta: sub_resellersz1bAfdNTTsMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/sub_resellers.vue")
  },
  {
    name: "admin-roles-users",
    path: "/admin/roles/users",
    meta: usersvrGtarOiY8Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/roles/users.vue")
  },
  {
    name: "admin-search_keywords",
    path: "/admin/search_keywords",
    meta: search_keywordsKRGaHpDi9IMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/search_keywords.vue")
  },
  {
    name: "admin-settings-manage_ads",
    path: "/admin/settings/manage_ads",
    meta: manage_adsNiekPp5EKjMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_ads.vue")
  },
  {
    name: "admin-settings-manage_notifications",
    path: "/admin/settings/manage_notifications",
    meta: manage_notificationsKx6EeEx7oBMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_notifications.vue")
  },
  {
    name: "admin-settings-manage_policies_verification",
    path: "/admin/settings/manage_policies_verification",
    meta: manage_policies_verificationAyHYn6Sw3SMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_policies_verification.vue")
  },
  {
    name: "admin-settings-manage_seo",
    path: "/admin/settings/manage_seo",
    meta: manage_seozGx2sMIdexMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_seo.vue")
  },
  {
    name: "admin-settings-manage_website",
    path: "/admin/settings/manage_website",
    meta: manage_websiteA7r7KUgE7CMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage_website.vue")
  },
  {
    name: "admin-settings-manage-points",
    path: "/admin/settings/manage-points",
    meta: manage_45pointsNf3HFtP56WMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/manage-points.vue")
  },
  {
    name: "admin-settings-wizard",
    path: "/admin/settings/wizard",
    meta: wizardiNvS7nceKpMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/settings/wizard.vue")
  },
  {
    name: "admin-stores_verification_requests",
    path: "/admin/stores_verification_requests",
    meta: stores_verification_requestsFA1IkmzbaaMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/stores_verification_requests.vue")
  },
  {
    name: "admin-stores",
    path: "/admin/stores",
    meta: stores0n5umrJok2Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/stores.vue")
  },
  {
    name: "admin-warnings",
    path: "/admin/warnings",
    meta: indexLr7LuHvrQZMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/warnings/index.vue")
  },
  {
    name: "admin-withdrawal-requests",
    path: "/admin/withdrawal-requests",
    meta: withdrawal_45requests2juZmpOOpnMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/admin/withdrawal-requests.vue")
  },
  {
    name: "Cart_2",
    path: "/Cart_2",
    meta: Cart_2L1AmgAmuvtMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/Cart_2.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartx2EwTwKZrjMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/cart.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesAgMO936xHtMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/categories.vue")
  },
  {
    name: "category-content-id",
    path: "/category-content/:id()",
    meta: _91id_93SmB7wEqu0QMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/category-content/[id].vue")
  },
  {
    name: "chats-chatId",
    path: "/chats/:chatId?",
    meta: _91_91chatId_93_93RV6DCpSasvMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/chats/[[chatId]].vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    meta: contact_45usgZoQcegC7gMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/contact-us.vue")
  },
  {
    name: "delivery-locations",
    path: "/delivery-locations",
    meta: delivery_45locationsMJFwdCUVnNMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/delivery-locations.vue")
  },
  {
    name: "exclusive_offers-id",
    path: "/exclusive_offers/:id?",
    meta: _91_91id_93_938SwOTirQDNMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/exclusive_offers/[[id]].vue")
  },
  {
    name: "favourite-type",
    path: "/favourite/:type?",
    meta: _91_91type_93_93ewpQor97dJMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/favourite/[[type]].vue")
  },
  {
    name: "follow_up",
    path: "/follow_up",
    meta: follow_upH5gcPLiH41Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/follow_up.vue")
  },
  {
    name: "followers",
    path: "/followers",
    meta: followersjsfmlLH5GoMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/followers.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexvse7dtAc8nMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/index.vue")
  },
  {
    name: "login-type",
    path: "/login/:type?",
    meta: _91_91type_93_935AdsvdmjEJMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/login/[[type]].vue")
  },
  {
    name: "moderator-dashboard",
    path: "/moderator/dashboard",
    meta: dashboardtn6KIEnVD3Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/dashboard.vue")
  },
  {
    name: "moderator",
    path: "/moderator",
    meta: index3bSNRcvtjaMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/index.vue")
  },
  {
    name: "moderator-logs",
    path: "/moderator/logs",
    meta: logsGpcjwjM0gPMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/logs.vue")
  },
  {
    name: "moderator-my_profile_settings",
    path: "/moderator/my_profile_settings",
    meta: my_profile_settingsAisWiI7QArMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/my_profile_settings.vue")
  },
  {
    name: "moderator-notification-logs",
    path: "/moderator/notification-logs",
    meta: notification_45logsn3nINxc6Q8Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/notification-logs.vue")
  },
  {
    name: "moderator-offers",
    path: "/moderator/offers",
    meta: offersyU90D4QLLrMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/offers.vue")
  },
  {
    name: "moderator-orders",
    path: "/moderator/orders",
    meta: ordersox3BLbip7cMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/orders.vue")
  },
  {
    name: "moderator-products",
    path: "/moderator/products",
    meta: productsMedL82FC5eMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/products.vue")
  },
  {
    name: "moderator-reports-orders",
    path: "/moderator/reports/orders",
    meta: ordersKzTHuCbyuvMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/orders.vue")
  },
  {
    name: "moderator-reports-products",
    path: "/moderator/reports/products",
    meta: productsESbHARm3SHMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/products.vue")
  },
  {
    name: "moderator-reports-stores",
    path: "/moderator/reports/stores",
    meta: storeseYgPZnkRObMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/reports/stores.vue")
  },
  {
    name: "moderator-roles-resellers",
    path: "/moderator/roles/resellers",
    meta: resellersAHPiqn1mbfMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/resellers.vue")
  },
  {
    name: "moderator-roles-sub_resellers",
    path: "/moderator/roles/sub_resellers",
    meta: sub_resellersG8a5f7zpOhMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/sub_resellers.vue")
  },
  {
    name: "moderator-roles-users",
    path: "/moderator/roles/users",
    meta: usersMNNQ6rEA6eMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/roles/users.vue")
  },
  {
    name: "moderator-search_keywords",
    path: "/moderator/search_keywords",
    meta: search_keywordsB7GfDpG54WMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/search_keywords.vue")
  },
  {
    name: "moderator-stores",
    path: "/moderator/stores",
    meta: storesgfxK6tNA33Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/stores.vue")
  },
  {
    name: "moderator-warnings",
    path: "/moderator/warnings",
    meta: indexRlysUhJ1WYMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/moderator/warnings/index.vue")
  },
  {
    name: "my-stores-components-MyStoreCard",
    path: "/my-stores/components/MyStoreCard",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/MyStoreCard.vue")
  },
  {
    name: "my-stores-components-PaymentComponent",
    path: "/my-stores/components/PaymentComponent",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/PaymentComponent.vue")
  },
  {
    name: "my-stores-components-RenewOptionsButton",
    path: "/my-stores/components/RenewOptionsButton",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/RenewOptionsButton.vue")
  },
  {
    name: "my-stores-components-ShareButton",
    path: "/my-stores/components/ShareButton",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/components/ShareButton.vue")
  },
  {
    name: "my-stores",
    path: "/my-stores",
    meta: indexGdSaHbOKd9Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/my-stores/index.vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    meta: _91id_93knlBwq2WBlMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/news/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsGX5yoZpYmMMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/notifications.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: ordersLAYQ1m1x6pMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/orders.vue")
  },
  {
    name: "otp",
    path: "/otp",
    meta: otpJruII9aRhQMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/otp.vue")
  },
  {
    name: "panel-Login",
    path: "/panel/Login",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/panel/Login.vue")
  },
  {
    name: "payment-state-from",
    path: "/payment-state/:from?",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/payment-state/[[from]].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyBAiw2wVJCOMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/privacy-policy.vue")
  },
  {
    name: "products-storeusername-id-productname",
    path: "/products/:storeusername()/:id()/:productname?",
    meta: indexnfEdQF7RbQMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/[[productname]]/index.vue")
  },
  {
    name: "products-storeusername-id-productname-order-details",
    path: "/products/:storeusername()/:id()/:productname?/order-details",
    meta: order_45detailsq7WU3Kr0DsMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/[[productname]]/order-details.vue")
  },
  {
    name: "products-storeusername-id-MakingReportModal",
    path: "/products/:storeusername()/:id()/MakingReportModal",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/products/[storeusername]/[id]/MakingReportModal.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: index9eoyMyqA4fMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/products/index.vue")
  },
  {
    name: "products-store-password",
    path: "/products/store-password",
    meta: index3XuM6hdVbtMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/products/store-password/index.vue")
  },
  {
    name: "profile-type",
    path: "/profile/:type?",
    meta: _91_91type_93_93AIvAiHiCjIMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/profile/[[type]].vue")
  },
  {
    name: "promotion",
    path: "/promotion",
    meta: promotion4MgFaEaQ72Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/promotion.vue")
  },
  {
    name: "rating-management",
    path: "/rating-management",
    meta: rating_45managementjk66strsZHMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/rating-management.vue")
  },
  {
    name: "rating-type-id",
    path: "/rating/:type()/:id()",
    meta: _91id_93JAWW9R8czXMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/rating/[type]/[id].vue")
  },
  {
    name: "reseller-branches",
    path: "/reseller/branches",
    meta: brancheseF0SrziZGXMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/branches.vue")
  },
  {
    name: "reseller-dashboard",
    path: "/reseller/dashboard",
    meta: dashboardKcpr5b3LfXMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/dashboard.vue")
  },
  {
    name: "reseller-delivery_governorates-store_id-store",
    path: "/reseller/delivery_governorates/:store_id?/:store?",
    meta: _91_91store_93_93EHrMvCR0NGMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/delivery_governorates/[[store_id]]/[[store]].vue")
  },
  {
    name: "reseller-exclusive_offers",
    path: "/reseller/exclusive_offers",
    meta: exclusive_offersezkq1namFYMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/exclusive_offers.vue")
  },
  {
    name: "reseller",
    path: "/reseller",
    meta: index2WMsLk3SWnMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/index.vue")
  },
  {
    name: "reseller-manage_ads-add",
    path: "/reseller/manage_ads/add",
    meta: addcL38UnihG1Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ads/add.vue")
  },
  {
    name: "reseller-manage_ads",
    path: "/reseller/manage_ads",
    meta: indexDGb4rP13nDMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ads/index.vue")
  },
  {
    name: "reseller-manage_news",
    path: "/reseller/manage_news",
    meta: manage_newsIwkSPD763JMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_news.vue")
  },
  {
    name: "reseller-manage_ratings",
    path: "/reseller/manage_ratings",
    meta: manage_ratings7K9Uq32sATMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/manage_ratings.vue")
  },
  {
    name: "reseller-my_profile_settings",
    path: "/reseller/my_profile_settings",
    meta: my_profile_settingsShwuhgpNtiMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/my_profile_settings.vue")
  },
  {
    name: "reseller-orders",
    path: "/reseller/orders",
    meta: ordersrMqKslKONtMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/orders.vue")
  },
  {
    name: "reseller-package_invoices",
    path: "/reseller/package_invoices",
    meta: package_invoices03nKj0g83CMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/package_invoices.vue")
  },
  {
    name: "reseller-product_coupons",
    path: "/reseller/product_coupons",
    meta: product_couponsiKAKfO2FtPMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/product_coupons.vue")
  },
  {
    name: "reseller-products",
    path: "/reseller/products",
    meta: products49pvZYLMEmMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/products.vue")
  },
  {
    name: "reseller-reports-orders",
    path: "/reseller/reports/orders",
    meta: ordersBckE5sOYarMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/orders.vue")
  },
  {
    name: "reseller-reports-products",
    path: "/reseller/reports/products",
    meta: productsJlgAuXcaWUMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/products.vue")
  },
  {
    name: "reseller-reports-stores",
    path: "/reseller/reports/stores",
    meta: storesqtVuASJQqSMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/reports/stores.vue")
  },
  {
    name: "reseller-stores_verification",
    path: "/reseller/stores_verification",
    meta: stores_verificationu08A3OvIzDMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/stores_verification.vue")
  },
  {
    name: "reseller-stores",
    path: "/reseller/stores",
    meta: storesh8hiR6VBU3Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/stores.vue")
  },
  {
    name: "reseller-sub_resellers",
    path: "/reseller/sub_resellers",
    meta: sub_resellersceOAhh7shBMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/reseller/sub_resellers.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexd43HI24VKXMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/search/index.vue")
  },
  {
    name: "search-with-filter",
    path: "/search/with-filter",
    meta: with_45filter7wYKfmpjkFMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/search/with-filter.vue")
  },
  {
    name: "security_settings",
    path: "/security_settings",
    meta: security_settings53Za9zhRsPMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/security_settings.vue")
  },
  {
    name: "store-settings-id",
    path: "/store-settings/:id()",
    meta: _91id_93wmRi2bwpvxMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/store-settings/[id].vue")
  },
  {
    name: "store-settings-components-Locations",
    path: "/store-settings/components/Locations",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/store-settings/components/Locations.vue")
  },
  {
    name: "store-username",
    path: "/store/:username?",
    meta: _91_91username_93_9360gscCyJ9fMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/store/[[username]].vue")
  },
  {
    name: "store-store-password-username",
    path: "/store/store-password/:username?",
    meta: _91_91username_93_93HjiULD3sTFMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/store/store-password/[[username]].vue")
  },
  {
    name: "stores",
    path: "/stores",
    meta: indexAAZCuZgdMEMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/stores/index.vue")
  },
  {
    name: "sub_reseller-branches",
    path: "/sub_reseller/branches",
    meta: branchestKSRexgPs9Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/branches.vue")
  },
  {
    name: "sub_reseller-dashboard",
    path: "/sub_reseller/dashboard",
    meta: dashboardqURm6SeDdvMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/dashboard.vue")
  },
  {
    name: "sub_reseller-exclusive_offers",
    path: "/sub_reseller/exclusive_offers",
    meta: exclusive_offersAwFjEiogiuMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/exclusive_offers.vue")
  },
  {
    name: "sub_reseller",
    path: "/sub_reseller",
    meta: indexueKd7uNfzZMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/index.vue")
  },
  {
    name: "sub_reseller-manage_ads-add",
    path: "/sub_reseller/manage_ads/add",
    meta: add4O2c0mjbWkMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ads/add.vue")
  },
  {
    name: "sub_reseller-manage_ads",
    path: "/sub_reseller/manage_ads",
    meta: indexUdnTElbgisMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ads/index.vue")
  },
  {
    name: "sub_reseller-manage_news",
    path: "/sub_reseller/manage_news",
    meta: manage_newszrLwJ28ne9Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_news.vue")
  },
  {
    name: "sub_reseller-manage_ratings",
    path: "/sub_reseller/manage_ratings",
    meta: manage_ratingssbufdVdbteMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/manage_ratings.vue")
  },
  {
    name: "sub_reseller-my_profile_settings",
    path: "/sub_reseller/my_profile_settings",
    meta: my_profile_settings500AEZghvAMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/my_profile_settings.vue")
  },
  {
    name: "sub_reseller-orders",
    path: "/sub_reseller/orders",
    meta: ordersX6050F7EmYMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/orders.vue")
  },
  {
    name: "sub_reseller-package_invoices",
    path: "/sub_reseller/package_invoices",
    meta: package_invoicesHHiFHwYvK9Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/package_invoices.vue")
  },
  {
    name: "sub_reseller-product_coupons",
    path: "/sub_reseller/product_coupons",
    meta: product_couponsZdPSfWaF2tMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/product_coupons.vue")
  },
  {
    name: "sub_reseller-products",
    path: "/sub_reseller/products",
    meta: productsOiBhLbmuQGMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/products.vue")
  },
  {
    name: "sub_reseller-stores_verification",
    path: "/sub_reseller/stores_verification",
    meta: stores_verificationY6xx9oCeYoMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/stores_verification.vue")
  },
  {
    name: "sub_reseller-stores",
    path: "/sub_reseller/stores",
    meta: storeseBGzHcvdssMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/sub_reseller/stores.vue")
  },
  {
    name: "terms-condition",
    path: "/terms-condition",
    meta: terms_45condition0YRfYB7cEaMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/terms-condition.vue")
  },
  {
    name: "test-seo",
    path: "/test-seo",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/test-seo.vue")
  },
  {
    name: "test-social-preview",
    path: "/test-social-preview",
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/test-social-preview.vue")
  },
  {
    name: "upgrade-type",
    path: "/upgrade/:type?",
    meta: _91_91type_93_93BusXyGV5sYMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/upgrade/[[type]].vue")
  },
  {
    name: "verify_my_store",
    path: "/verify_my_store",
    meta: indexaldRPcjRLMMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/verify_my_store/index.vue")
  },
  {
    name: "verify_my_store-verification_process",
    path: "/verify_my_store/verification_process",
    meta: verification_processXsnUbOAsDUMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/verify_my_store/verification_process.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    meta: walletzkKMaE1OKOMeta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/wallet.vue")
  },
  {
    name: "win-with-cezma",
    path: "/win-with-cezma",
    meta: win_45with_45cezmaWU7eysFcR1Meta || {},
    component: () => import("/home/nuxt-front-end-V2/nuxt-front-end/pages/win-with-cezma.vue")
  },
  {
    name: component_45stubpEHXXpoq5iMeta?.name,
    path: "/panel",
    component: component_45stubpEHXXpoq5i
  },
  {
    name: component_45stubpEHXXpoq5iMeta?.name,
    path: "/admin/login",
    component: component_45stubpEHXXpoq5i
  },
  {
    name: component_45stubpEHXXpoq5iMeta?.name,
    path: "/moderator/login",
    component: component_45stubpEHXXpoq5i
  },
  {
    name: component_45stubpEHXXpoq5iMeta?.name,
    path: "/reseller/login",
    component: component_45stubpEHXXpoq5i
  },
  {
    name: component_45stubpEHXXpoq5iMeta?.name,
    path: "/sub_reseller/login",
    component: component_45stubpEHXXpoq5i
  }
]